import React from 'react';
import PropTypes from 'prop-types';
import VariantMap from './SiteFooter.variants';
import './SiteFooter.css';

const SiteFooter = props => {
  const { variation, className, ...rest } = props;
  const Body = VariantMap.mainBody[variation];
  const Footer = VariantMap.footer[variation];

  return (
    <div className={className}>
      <Body {...rest} />
      <Footer {...rest} />
    </div>
  );
};

SiteFooter.propTypes = {
  variation: PropTypes.oneOf([
    'ExtensiveSitemap',
    'CenterStacked',
    'BasicFishermanBanner',
    'CenterStackedV2',
    'Simple',
    'Services',
    'SubscriptionBanner',
  ]),
  pages: PropTypes.arrayOf(
    PropTypes.arrayOf(
      PropTypes.shape({
        pageTitle: PropTypes.string.isRequired,
        slug: PropTypes.string.isRequired,
        internal: PropTypes.bool.isRequired,
      }),
    ),
  ).isRequired,
  ctas: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      link: PropTypes.string.isRequired,
      internal: PropTypes.bool.isRequired,
    }),
  ),
  contactInformation: PropTypes.shape({
    address: PropTypes.shape({
      street: PropTypes.string.isRequired,
      city: PropTypes.string.isRequired,
      state: PropTypes.string.isRequired,
      zip: PropTypes.string.isRequired,
    }),
    phoneNumber: PropTypes.string.isRequired,
    email: PropTypes.string,
  }),
  socialMedia: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
      link: PropTypes.string.isRequired,
    }),
  ),
  services: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      content: PropTypes.string.isRequired,
      link: PropTypes.string.isRequired,
    }),
  ),
  hours: PropTypes.arrayOf(
    PropTypes.shape({
      day: PropTypes.number.isRequired,
      open: PropTypes.number.isRequired,
      close: PropTypes.number.isRequired,
      label: PropTypes.string,
    }),
  ),
  subscribe: PropTypes.shape({
    header: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
  }),
  aboutUs: PropTypes.shape({
    header: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
  }),
  termsOfService: PropTypes.shape({
    text: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
  }),
  copyright: PropTypes.shape({
    company: PropTypes.string.isRequired,
    phrase: PropTypes.string.isRequired,
  }),
  logo: PropTypes.string,
  bodyColor: PropTypes.string,
  bottomColor: PropTypes.string,
  className: PropTypes.string,
};

SiteFooter.defaultProps = {
  variation: 'ExtensiveSitemap',
  className: 'fc-footer',
  ctas: [],
  services: [],
  contactInformation: null,
  socialMedia: [],
  hours: [],
  subscribe: null,
  aboutUs: null,
  termsOfService: null,
  copyright: null,
  logo: '',
  bodyColor: '#C9DAF4',
  bottomColor: '#90ACD7',
};

export default SiteFooter;
